import { useFormContext } from 'react-hook-form';
import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';

import {
  IInviteAdjudicatorsForm,
  IInviteExperts,
  IInviteExternalExpert
} from './commonTypes';

interface Props {
  onClose: () => void;
  onInviteExperts: () => void;
  isProcessing: boolean;
  isAdjudicator?: boolean;
}

const ConfirmInviteBoardMemberModal = ({
  onClose,
  onInviteExperts,
  isProcessing,
  isAdjudicator
}: Props) => {
  const methods = useFormContext<IInviteAdjudicatorsForm>();
  const { getValues } = methods;
  const experts = getValues('experts');

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      width="448px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <FontAwesomeIcon
          icon={faEnvelope}
          style={{ width: '40px', height: '40px' }}
        />

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">
            Invite {isAdjudicator ? 'Adjudicators?' : 'Experts?'}
          </Text>
          <Text textStyle="textBody">
            You will send invites to the following{' '}
            {isAdjudicator ? 'Adjudicators' : 'experts'}:
          </Text>
        </Flex>

        <Flex flexDirection="column" gap={4}>
          {experts.length > 0 && (
            <>
              <ul>
                {experts.map(
                  (expert: IInviteExperts & IInviteExternalExpert) => (
                    <>
                      {expert.externalExpertEmail ? (
                        <li key={expert.externalExpertEmail}>
                          <Text textStyle="textContext">{`${expert.externalExpertEmail}`}</Text>
                        </li>
                      ) : (
                        <li key={expert.id}>
                          <Text textStyle="textContext">{`${expert.name} (${expert.email})`}</Text>
                        </li>
                      )}
                    </>
                  )
                )}
              </ul>
            </>
          )}
        </Flex>

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onInviteExperts}
            isDisabled={isProcessing}
          >
            Invite {isAdjudicator ? 'Adjudicators' : 'Experts'}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConfirmInviteBoardMemberModal;
